
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/health/[...slug]",
      function () {
        return require("private-next-pages/health/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/health/[...slug]"])
      });
    }
  